// extracted by mini-css-extract-plugin
export default {"label_spec":"closeWarning_label_spec__KQA5E","warning":"closeWarning_warning__GKcfn","acces_err_warning":"closeWarning_acces_err_warning__vqFVN"};